import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const CurrencyRateFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'currencyRateId',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'currencyCodeFrom',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.currencyOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'currencyCodeTo',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.currencyOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'dateEffectiveOnFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'dateEffectiveOnTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
